import { NavigationToggle } from "./NavigationToggle"

export const MenuHamburger = {
	handlerOpen: () => {
		const target = document.querySelector('#menu-hamburger')
		
		target.onclick = () => {
			NavigationToggle.state('active')
		}
	},
	handlerClose: () => {
		const target = document.querySelector('#menu-close')
		
		target.onclick = () => {
			NavigationToggle.state('close')
		}
	},
	init: () => {
		MenuHamburger.handlerOpen()
		MenuHamburger.handlerClose()
	}
}